import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Logo } from "./Logo";
import { COMPANY } from "../data/site";

const links = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header
      className="sticky top-0 z-50 bg-white/95 backdrop-blur-xl border-b border-border"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-5 md:px-10 h-20 flex items-center justify-between">
        <Link to="/" data-testid="nav-home-logo" aria-label="Hyltons Healthcare Solutions home">
          <Logo />
        </Link>

        <nav className="hidden lg:flex items-center gap-9" data-testid="desktop-nav">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-base font-heading font-semibold uppercase tracking-wider transition-colors ${
                  isActive ? "text-brand-red" : "text-brand-darkBlue hover:text-brand-red"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-4">
          <a
            href={`tel:${COMPANY.phone}`}
            data-testid="nav-phone"
            className="flex items-center gap-2 text-brand-darkBlue font-semibold"
          >
            <Phone className="w-5 h-5" />
            {COMPANY.phone}
          </a>
          <Link
            to="/contact#consultation"
            data-testid="nav-book-consultation-btn"
            className="bg-brand-red text-white font-semibold py-3 px-6 rounded-full hover:bg-brand-redDark transition-colors focus:outline-none focus:ring-4 focus:ring-red-200"
          >
            Book Consultation
          </Link>
        </div>

        <button
          className="lg:hidden text-brand-darkBlue p-2"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X className="w-8 h-8" /> : <Menu className="w-8 h-8" />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-border bg-white px-5 py-4" data-testid="mobile-nav">
          <nav className="flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                data-testid={`mobile-nav-link-${l.label.toLowerCase()}`}
                className={({ isActive }) =>
                  `text-lg font-heading font-semibold uppercase tracking-wider py-3 px-2 rounded-lg ${
                    isActive ? "text-brand-red bg-brand-lightBlue" : "text-brand-darkBlue"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link
              to="/contact#consultation"
              data-testid="mobile-book-consultation-btn"
              className="mt-3 text-center bg-brand-red text-white font-semibold py-4 px-6 rounded-full"
            >
              Book Consultation
            </Link>
          </nav>
        </div>
      )}
    </header>
  );
};
